import React from "react";
import styled from "styled-components";

const ContentBodyStyle = styled.div`
    top: 61px;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 30px 30px 0 30px;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;

    /* because padding bottom doesn't work */
    /* TODO: is absolute position realy needed? */
    > .after {
        left: 0;
        right: 0;
        height: 40px;
        position: absolute;
    }
`;

export const ContentBody = ({ children }) =>
    <ContentBodyStyle id="contentBody">
        {children}
        <div className="after" />
    </ContentBodyStyle>;